import chatbotRequest from '../http'
import type { OnlineChannelReq, OnlineChannelRes } from '../types/onlineChannel'

export function onlineChannelApi(data: OnlineChannelReq): Promise<OnlineChannelRes> {
    return chatbotRequest<OnlineChannelRes, OnlineChannelReq, OnlineChannelRes>({
        url: '/api/channel/online',
        method: 'post',
        data,
    })
}